import { EAssetType } from 'constants/enums';
import { POPUP_DEFAULTS } from 'views/OfferDesign/OfferDesign.consts';

import { GradientFieldConfig, NumberFieldConfig, UploadFieldConfig } from '../FormFields.types';

export { POPUP_DEFAULTS };

export const BORDER_COLOR_CONFIG: GradientFieldConfig = {
  header: 'Fill Color',
  name: 'borderColor',
  fallback: POPUP_DEFAULTS.borderColor
};

export const BORDER_WIDTH_CONFIG: NumberFieldConfig = {
  label: 'Width (in px)',
  name: 'borderWidth',
  min: 0
};

export const FONT_WEIGHT_OPTIONS = [
  { value: 'normal', label: 'Regular' },
  { value: 'medium', label: 'Medium' },
  { value: 'bold', label: 'Bold' }
];

export const BG_COLOR_FIELDS: GradientFieldConfig[] = [
  {
    header: 'Background Color',
    name: 'backgroundColor',
    fallback: POPUP_DEFAULTS.backgroundColor
  }
];

export const UPLOAD_FIELDS: UploadFieldConfig[] = [
  {
    title: 'Background Image',
    fieldName: 'backgroundImage',
    forceType: EAssetType.BG_BUNDLE,
    tooltip: 'Upload a background image for the popup offer card',
    isRequired: true
  },
  {
    title: 'Badge Image',
    fieldName: 'badgeCoverImage',
    forceType: EAssetType.BG_BUNDLE,
    tooltip: 'Upload a badge image for the popup'
  }
];

export const TITLE_DEFAULTS = {
  fontColor: POPUP_DEFAULTS.fontColor,
  fontSize: POPUP_DEFAULTS.fontSize
};
